import { sendOnboardingDocument } from 'commons/service/bank/onboardingDocuments'
import { WriteHook, useMutationManager } from 'state-manager'

export const useSendOnboardingDocument: WriteHook<number, void> = (opts) =>
  useMutationManager<number, void>(sendOnboardingDocument, opts)
